import { jsx } from 'react/jsx-runtime';
import { forwardRef, useContext, useCallback, useLayoutEffect } from 'react';
import { useSharedRef } from '../hooks/use-shared-ref.js';
import { RadioContext } from './radio-context.js';

/**
 * Option to be used in a `Radio` or `RadioPrimitive`
 */
const Option = forwardRef(function Option({ value: valueIn, readonly, ...props }, refIn) {
    const ref = useSharedRef(refIn);
    const { name, value, onChange, readonlyGroup, autofocus } = useContext(RadioContext);
    // If readonly on the Root is true, Option's readonly cannot override to false
    const isReadonly = readonlyGroup || readonly || undefined;
    const handleChange = useCallback((event) => {
        if (isReadonly)
            return;
        onChange(event.target.value, { event });
    }, [isReadonly, onChange]);
    const checked = value === valueIn;
    useLayoutEffect(() => {
        ref.current.autofocus = checked && autofocus;
    }, [ref, checked, autofocus]);
    // aria-readonly support is bad, so I add aria-disabled so AT will read it as disabled but still be
    // focusable: https://github.com/FreedomScientific/standards-support/issues/620
    // aria attributes need to be undefined so they don't show up in dom if false
    /* oxlint-disable role-supports-aria-props */
    return (jsx("input", { "data-fpl-component": "primitive", ...props, ref: ref, "aria-readonly": isReadonly, "aria-disabled": isReadonly, checked: value === valueIn, onKeyDown: (e) => {
            if (e.key === 'Escape')
                e.currentTarget.blur();
        }, name: name, onChange: handleChange, type: "radio", value: valueIn }));
});
Option.displayName = 'RadioPrimitive.Option';

export { Option };
//# sourceMappingURL=radio-option.js.map
